<template>
    <el-row>
        <el-col :span="24">
            <text>检测员/核对人员：{{orderAreaDevice.userAlias}}</text>
<!--            <text>检测员/核对人员：xxxddd{{Record}}</text>-->
<!--            <text>检测员/核对人员：xxxddd{{orderAreaDevice}}</text>-->
            <el-descriptions
                    class="margin-top"
                    title="设备信息"
                    :column="3"
                    :size="size"
                    border
            >
                <template #extra>
                    <el-button type="primary" @click="update(vDeviceArea)">查看/修改</el-button>
                </template>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            <el-icon :style="iconStyle">
                                <user />
                            </el-icon>
                            使用单位代码
                        </div>
                    </template>
                    {{ vDeviceArea.unitCode }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            <el-icon :style="iconStyle">
                                <iphone />
                            </el-icon>
                            产品编号
                        </div>
                    </template>
                    {{ vDeviceArea.liftNum }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            <el-icon :style="iconStyle">
                                <location />
                            </el-icon>
                            设备品种
                        </div>
                    </template>
                    {{ vDeviceArea.liftType }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            <el-icon :style="iconStyle">
                                <tickets />
                            </el-icon>
                            使用单位
                        </div>
                    </template>
                    <el-tag size="small">{{ vDeviceArea.unit }}</el-tag>
                </el-descriptions-item>

            </el-descriptions>
        </el-col>
        <el-col :span="24">
            <div style="margin-top: 20px" >
            <span style="float: left; font-size:16px; font-weight: 700; ">现场条件：</span>
            <el-checkbox-group
                    v-model="saveID">
                <el-checkbox  v-for="(item) in explainList" :label="item.explainId" :key="item.explainId"
                             @change="handleCheckedCitiesChange"  :checked="saveID.includes(item.explainId)"  >
                    <div class="infoCard_box" style="">
<!--                        :checked="saveID.includes(item.explainId)"-->
                    <div :style="item.explainId===1?'line-height: 3;':''">{{item.explainName}}</div>
                            <div v-if="item.explainId===1" class="infoCard_boxnet" style="">
                                <div class="infoCard_boxinp" style="">
                                    <span>温度(℃):</span>
                                    <el-input v-model="temp" placeholder="请输入温度(℃)" class="search-input"
                                                   >
                                    </el-input>
                                </div>
                                <div class="infoCard_boxinp">
                                    <text>湿度(%):</text>
                                    <el-input v-model="humidity" placeholder="请输入湿度(%)" class="search-input"
                                                   >
                                    </el-input>
                                </div>
                                <div class="infoCard_boxinp">
                                    <text>电压(V):</text>
                                    <el-input v-model="voltage" placeholder="请输入电压(V)" class="search-input"
                                                   >
                                    </el-input>
                                </div>
                            </div>
                    </div>

                </el-checkbox>
            </el-checkbox-group>
            </div>
<!--            v-if="vDeviceArea.lifeKind==='自动扶梯与自动人行道'"-->
<!--            <div class="infoCard" style="">-->
<!--                <view class="infoCard_box2" style=" ">-->
<!--                    <text class="infoCard_box2txt" style="">观测数据及测量结果记录</text>-->
<!--                    <el-button  class="infoCard_box2but" type="primary" @click="toObserved" style="" size="mini">查看/修改</el-button >-->
<!--                </view>-->
<!--            </div>-->
            <el-descriptions
                    v-if="vDeviceArea.lifeKind==='自动扶梯与自动人行道'"
                    class="margin-top"
                    title="观测数据及测量结果记录"
                    :size="size"
                    border
            >
                <template #extra>
                    <el-button type="primary" @click="toObserved">查看/修改</el-button>
                </template>
            </el-descriptions>
        </el-col>
        <el-col :span="24">
            <el-descriptions
                    class="margin-top"
                    title="检测场景"
            >
            </el-descriptions>
            <div v-for="(item, index) in moduleList" :key="index" >

                <div class="infoCard">
                    <div class="infoCard_box3" style=" ">
                        <text class="infoCard_box3text" style=" ">{{item}}</text>
                        <el-button type="primary" @click="queryHoistway(item)" class="infoCard_box3but" style=" "
                                size="mini">查看/修改</el-button>

                    </div>

                    <div class="infoCard_box3net" style=" ">
                        <div class="infoCard_box3netboy" style="">
                            <text class="infoCard_box3netboytxtl" style="">检查项目 </text>
                            <text class="infoCard_box3netboytxtr" style=" ">{{detectioncount[index]}}</text>
                        </div>
                        <div class="infoCard_box3netboy" style="">
                            <text class="infoCard_box3netboytxtl">检查合格项 </text>
                            <text class="infoCard_box3netboytxtr"> {{successList[index]}}</text>
                        </div>
                        <div class="infoCard_box3netboy" style=" ">
                            <text class="infoCard_box3netboytxtl">检查不合格项 </text>
                            <text class="infoCard_box3netboytxtr2">{{falseList[index]}}</text>
                        </div>
                    </div>
<!--                 class="infoCard_box3"   <span>完成进度</span>-->
                    <div  >
                       <el-progress style=" " :percentage="pgList[index]"  :stroke-width="18" />
                    </div>
                </div>
            </div>
            <el-descriptions
                    class="margin-top"
                    title="备注"
            >
            </el-descriptions>
            <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    v-model="Record.notes"
                    maxlength="1000"
                    show-word-limit
            ></el-input>
            <div class="infoCard_box3" >
            <el-date-picker @change="detectionDateChange"
                    v-model="this.Record.recDate"
                    type="date"
                    placeholder="检测日期"
                    format="YYYY年MM月DD日"
                    style="width: 300px"
            >
            </el-date-picker>
            <el-date-picker @change="csDateChange"
                    v-model="this.Record.csignDate"
                    type="date"
                    placeholder="签收日期"
                    format="YYYY年MM月DD日"
                    style="width: 300px"
            >
            </el-date-picker>
            </div>
        </el-col>
        <el-col :span="24">
            <view class="footcard">
                <view>
                    <el-button class="nextBut" style=" " type="primary" @click="creatReport(1)">预览生成检测报告</el-button>
                </view>
                <view>
                    <el-button class="nextBut" style=" " type="primary" @click="createRecord(Record,1)">预览生成检测记录</el-button>
                </view>
                <view>
                    <el-button class="nextBut" style=" " type="primary" @click="creatReport(0)">生成检测报告</el-button>
                </view>


                <view>
                    <el-button class="nextBut2" style="" type="primary" @click="TocreatNotice">生成备忘录</el-button>
                </view>
                <view   class="footcardnet" style="">
<!--                    <view class="footcardnetboy" style="" @click="clickBack">退回</view>-->
                    <el-button class="nextBut2" style="" type="primary" @click="clickBack">退回</el-button>
                </view>
            </view>
            <!--  -->

        </el-col>
    </el-row>

    <el-dialog v-model="dialogFormVisibleEdit" title="编辑设备" :lock-scroll="false"
               width="80%">
        <!--        :fullscreen="true" draggable-->
        <el-row>
            <el-col :span="24">
                <el-form :model="editform" :inline="true" ref="editform" :rules="rules" status-icon label-width="140px">
                    <div>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="设备种类" prop="unit" style="width: 440px">
                                    <el-select style="width: 300px" v-model="editform.specialType" disabled="true"
                                               placeholder="请选择设备种类"
                                               clearable>
                                        <el-option label="电梯" :value="1"></el-option>
                                        <el-option label="起重器" :value="2"></el-option>

                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用单位名称" prop="unit" style="width: 440px">
                                    <el-input v-model="editform.unit"
                                              style="width: 300px" placeholder="请输入使用单位名称"
                                              clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                    </div>
                    <div v-show="editform.specialType===1">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="监察识别码" style="width: 440px" prop="superviseCode">
                                    <el-input v-model="editform.superviseCode"
                                              style="width: 300px" placeholder="请输入监察识别码"
                                              clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="额定载重量" prop="maxWeight" style="width: 440px">
                                    <el-input-number style="width: 300px" v-model="editform.maxWeight" :precision="1"
                                                     :step="1" :min="0"
                                                     :max="10000"></el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="设备使用地点" style="width: 440px">
                                    <el-select style="width: 300px" v-model="areaParentIdOne" placeholder="请选择"
                                               @change="queryAreaList2"
                                               clearable>
                                        <el-option v-for="(item, key) in areaList" v-bind:key="item" :label="item.areaName "
                                                   :value="key"></el-option>
                                    </el-select>
                                    <el-select style="width: 300px" v-model="areaParentIdTwo" placeholder="请选择"
                                               @change="queryAreaList3"
                                               clearable>
                                        <el-option v-for="(item, key) in areaList2" v-bind:key="item"
                                                   :label="item.areaName "
                                                   :value="key"></el-option>
                                    </el-select>
                                    <el-select style="width: 300px" v-model="areaParentIdThree" placeholder="请选择"
                                               @change="queryAreaList4"
                                               clearable>
                                        <el-option v-for="(item, key) in areaList3" v-bind:key="item"
                                                   :label="item.areaName "
                                                   :value="key"></el-option>
                                    </el-select>
                                    <el-input v-model="editform.detailArea" placeholder="请输入具体地址"
                                              style="width: 300px;" clearable autocomplete="off" show-word-limit
                                              maxlength="500" required></el-input>
                                    <!--                <el-select style="width: 300px" v-model="areaParentIdFour" @change="queryAreaList5" placeholder="请选择"-->
                                    <!--                           clearable>-->
                                    <!--                  <el-option v-for="(item, key) in areaList4" v-bind:key="item" :label="item.areaName "-->
                                    <!--                             :value="key"></el-option>-->
                                    <!--                </el-select>-->
                                    <!--                <el-select style="width: 300px" v-model="areaParentIdFive" placeholder="请选择" clearable>-->
                                    <!--                  <el-option v-for="(item, key) in areaList5" v-bind:key="item" :label="item.areaName "-->
                                    <!--                             :value="key"></el-option>-->
                                    <!--                </el-select>-->
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <div>
                                    <el-form-item label="额定压力" class="rightStyle">
                                        <el-input type="number" v-model="editform.pressure" placeholder="请输入额定压力"
                                                  style="width: 300px;" :min="0" clearable autocomplete="off" show-word-limit
                                                  maxlength="50" required></el-input>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="额定速度" prop="speed" class="rightStyle">
                                        <el-input-number style="width: 300px" v-model="editform.speed" :precision="2"
                                                         :step="0.1" :min="0"
                                                         :max="100"></el-input-number>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="额定速度（上行）" style="width: 440px" class="rightStyle">
                                        <el-input-number style="width: 300px" v-model="editform.speedUp" :precision="2"
                                                         :step="0.1" :min="0"
                                                         :max="100"></el-input-number>
                                    </el-form-item>
                                </div>

                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="设备所在区域" style="width: 440px" class="rightStyle">
                                    <el-input style="width: 300px" v-model="editform.lifeArea" placeholder="请输入设备所在区域"
                                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="楼盘名称" class="rightStyle">
                                    <el-input v-model="editform.propertyName" placeholder="请输入楼盘名称"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="分支机构名称" style="width: 440px" class="rightStyle">
                                    <el-input style="width: 300px" v-model="editform.branchName" placeholder="请输入分支机构名称"
                                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="驱动主机型号" class="rightStyle">
                                    <el-input v-model="editform.driveModel" placeholder="请输入驱动主机型号" :min="0"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="驱动主机编号" style="width: 440px" class="rightStyle">
                                    <el-input style="width: 300px" v-model="editform.driveCode" placeholder="请输入驱动主机编号"
                                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="控制柜型号" class="rightStyle">
                                    <el-input v-model="editform.controlBoxModel" placeholder="请输入控制柜型号" :min="0"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="控制柜编号" style="width: 440px" class="rightStyle">
                                    <el-input style="width: 300px" v-model="editform.controlBoxCode" placeholder="请输入控制柜编号"
                                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="轿厢限速器型号" class="rightStyle">
                                    <el-input v-model="editform.carModel" placeholder="请输入轿厢限速器型号"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="轿厢限速器编号" style="width: 440px" class="rightStyle">
                                    <el-input style="width: 300px" v-model="editform.carCode" placeholder="请输入轿厢限速器编号"
                                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="对重限速器型号" class="rightStyle">
                                    <el-input v-model="editform.counterweightModel" placeholder="请输入对重限速器型号"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="对重限速器编号" style="width: 440px" class="rightStyle">
                                    <el-input style="width: 300px" v-model="editform.counterweightModelCode"
                                              placeholder="请输入对重限速器编号"
                                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用单位地址" class="rightStyle">
                                    <el-input v-model="editform.unitArea" placeholder="请输入使用单位地址"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="分支机构地址" style="width: 440px" class="rightStyle">
                                    <el-input style="width: 300px" v-model="editform.branchArea" placeholder="请输入分支机构地址"
                                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="楼盘地址" class="rightStyle">
                                    <el-input v-model="editform.propertyArea" placeholder="请输入楼盘地址"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>


                            <el-col :span="12">
                                <div>
                                    <el-form-item label="上次检验日期格式" prop="preDateType" style="width: 440px">
                                        <el-select style="width: 300px" v-model="editform.preDateType"
                                                   @change="getDateType(editform.preDateType)"
                                                   placeholder="请选择日期格式" clearable>
                                            <el-option label="年月日" :value="'年月日'"></el-option>
                                            <el-option label="年月" :value="'年月'"></el-option>
                                            <el-option label="年" :value="'年'"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="上次检验日期" class="rightStyle">
                                        <el-date-picker
                                                v-model="editform.preDate"
                                                type="date"
                                                placeholder="上次检验日期"
                                                v-if="editform.preDateType==='年月日'"
                                                format="YYYY年MM月DD日"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.preDate"
                                                type="date"
                                                placeholder="上次检验日期"
                                                v-if="editform.preDateType==='年月'"
                                                format="YYYY年MM月"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.preDate"
                                                type="date"
                                                placeholder="上次检验日期"
                                                v-if="editform.preDateType==='年'"
                                                format="YYYY年"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>

                            </el-col>
                            <el-col :span="12">
                                <div>
                                    <el-form-item label="制造时间日期格式" prop="createDateType" style="width: 440px">
                                        <el-select style="width: 300px" v-model="editform.createDateType"
                                                   @change="getDateType(editform.createDateType)"
                                                   placeholder="请选择日期格式" clearable>
                                            <el-option label="年月日" :value="'年月日'"></el-option>
                                            <el-option label="年月" :value="'年月'"></el-option>
                                            <el-option label="年" :value="'年'"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="制造时间" class="rightStyle" prop="createDate">
                                        <el-date-picker
                                                v-model="editform.createDate"
                                                type="date"
                                                placeholder="制造时间"
                                                v-if="editform.createDateType==='年月日'"
                                                format="YYYY年MM月DD日"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.createDate"
                                                type="date"
                                                placeholder="制造时间"
                                                v-if="editform.createDateType==='年月'"
                                                format="YYYY年MM月"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.createDate"
                                                type="date"
                                                placeholder="制造时间"
                                                v-if="editform.createDateType==='年'"
                                                format="YYYY年"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>

                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="额定速度（下行）" style="width: 440px" class="rightStyle">
                                    <el-input-number style="width: 300px" v-model="editform.speedDown" :precision="2"
                                                     :step="0.1" :min="0"
                                                     :max="100"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="油缸数量" class="rightStyle">
                                    <el-input type="number" v-model="editform.hcNum" placeholder="请输入油缸数量" :min="0"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="满载压力" class="rightStyle">
                                    <el-input type="number" v-model="editform.maxPressure" :min="0" placeholder="请输入满载压力"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用单位代码" prop="unitCode">
                                    <el-input v-model="editform.unitCode" placeholder="请输入使用单位代码"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="层" class="rightStyle" prop="storey">
                                    <el-input type="number" :min="0" v-model="editform.storey" placeholder="请输入层数"
                                              clearable autocomplete="off" show-word-limit style="width: 300px"
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用登记证编号" prop="loginNum">
                                    <el-input v-model="editform.loginNum" class="rightStyle" placeholder="请输入使用登记证编号"
                                              clearable autocomplete="off" show-word-limit
                                              style="width: 300px"
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="站" class="rightStyle" prop="stand">
                                    <el-input type="number" v-model="editform.stand" placeholder="请输入站数"
                                              :min="0" clearable autocomplete="off" show-word-limit
                                              style="width: 300px"
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="单位内编码" class="rightStyle" prop="unitNum">
                                    <el-input v-model="editform.unitNum" placeholder="请输入单位内编码"
                                              clearable autocomplete="off" show-word-limit
                                              style="width: 300px"
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="门" class="rightStyle" prop="door">
                                    <el-input type="number" v-model="editform.door" :min="0" placeholder="请输入门数"
                                              clearable autocomplete="off" show-word-limit style="width: 300px"
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="设备注册代码" class="rightStyle" prop="lifeRegistCode">
                                    <el-input style="width: 300px" v-model="editform.lifeRegistCode" placeholder="请输入设备注册代码"
                                              clearable autocomplete="off" show-word-limit

                                              maxlength="50" required></el-input>

                                </el-form-item>

                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="控制方式" class="rightStyle" prop="controller">
                                    <el-select style="width: 300px" v-model="editform.controller" placeholder="请选择控制方式"
                                               clearable>
                                        <el-option label="集选" value="集选"></el-option>
                                        <el-option label="并联" value="并联"></el-option>
                                        <el-option label="群控" value="群控"></el-option>
                                        <el-option label="按钮" value="按钮"></el-option>
                                        <el-option label="信号控制" value="信号控制"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="设备代码" class="rightStyle" prop="lifeCode">
                                    <el-input style="width: 300px" v-model="editform.lifeCode" placeholder="请输入设备代码"
                                              clearable autocomplete="off" show-word-limit

                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="设备类别" class="rightStyle" prop="lifeKind">
                                    <el-select style="width: 300px" v-model="editform.lifeKind"
                                               @change="getliftType(editform.lifeKind,1)"
                                               placeholder="请选择设备类别" clearable>
                                        <el-option
                                                v-for="item in eqptypeList"
                                                :key="item"
                                                :label="item"
                                                :value="item"></el-option>
                                    </el-select>

                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="上端站" class="rightStyle">
                                    <el-input v-model="editform.upStation" placeholder="请输入上端站"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="设备品种" class="rightStyle" prop="liftType">
                                    <el-select style="width: 300px" v-model="editform.liftType" placeholder="请选择设备品种"
                                               clearable>
                                        <el-option
                                                v-for="item in liftTypeList"
                                                :key="item.liftType"
                                                :label="item.liftType"
                                                :value="item.liftType"
                                        ></el-option>
                                    </el-select>

                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="下端站" class="rightStyle">
                                    <el-input v-model="editform.downStation" placeholder="请输入下端站"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>

                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="基站" class="rightStyle">
                                    <el-input v-model="editform.baseStation" placeholder="请输入基站"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="产品型号" class="rightStyle" prop="liftModel">
                                    <el-input style="width: 300px" v-model="editform.liftModel" placeholder="请输入产品型号"
                                              clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="产品编号" class="rightStyle" prop="liftNum">
                                    <el-input v-model="editform.liftNum" placeholder="请输入产品编号"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="悬挂装置规格" class="rightStyle">
                                    <el-input v-model="editform.hangType" placeholder="请输入悬挂装置规格"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="悬挂装置数量" class="rightStyle">
                                    <el-input type="number" v-model="editform.hangNum" placeholder="请输入悬挂装置数量"
                                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="制造单位" class="rightStyle" prop="createUnit">
                                    <el-input style="width: 300px" v-model="editform.createUnit" placeholder="请输入制造单位"
                                              clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>

                            <el-col :span="12">
                                <el-form-item label="监督检验依据" style="width: 440px" class="rightStyle">
                                    <el-input style="width: 300px" v-model="editform.proof" placeholder="请输入监督检验依据"
                                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="防爆等级" class="rightStyle">
                                    <el-input v-model="editform.flameProof" placeholder="请输入防爆等级"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="燃爆物质" class="rightStyle">
                                    <el-input v-model="editform.material" placeholder="请输入燃爆物质"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="制造执行标准" class="rightStyle" prop="createStandard">
                                    <el-select style="width: 300px" v-model="editform.createStandard"
                                               placeholder="请选择制造执行标准" clearable>
                                        <el-option label="JG135-2000" value="JG135-2000"></el-option>
                                        <el-option label="GB25194-2010" value="GB25194-2010"></el-option>
                                        <el-option label="GB7588-1995" value="GB7588-1995"></el-option>
                                        <el-option label="GB7588-2003(不含第1号修改单)" value="GB7588-2003(不含第1号修改单)"></el-option>
                                        <el-option label="GB7588-2003（含第1号修改单）" value="GB7588-2003（含第1号修改单）"></el-option>
                                        <el-option label="GB/T16899-2011"
                                                   value="GB/T16899-2011"></el-option>
                                    </el-select>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="维护保养单位" class="rightStyle" prop="maintenance">
                                    <el-input v-model="editform.maintenance" style="width: 300px" placeholder="请输入维护保养单位"
                                              clearable autocomplete="off" show-word-limit

                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="整机防爆标志" class="rightStyle">
                                    <el-input v-model="editform.materialSign" placeholder="请输入整机防爆标志"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="安全钳类型" class="rightStyle">
                                    <el-select style="width: 300px" v-model="editform.safetyGear" placeholder="请选择安全钳类型"
                                               clearable>
                                        <el-option label="滚柱型瞬时式" value="滚柱型瞬时式"></el-option>
                                        <el-option label="楔块型瞬时式" value="楔块型瞬时式"></el-option>
                                        <el-option label="渐进式" value="渐进式"></el-option>
                                    </el-select>

                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="改造单位" class="rightStyle">
                                    <el-input v-model="editform.updateUnit" placeholder="请输入改造单位"
                                              clearable autocomplete="off" show-word-limit
                                              style="width: 300px"
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>

                            <el-col :span="12">
                                <el-form-item label="受检单位电话" class="rightStyle">
                                    <el-input type="number" v-model="editform.testedNum" placeholder="请输入受检单位电话"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="缓冲器形式" class="rightStyle">
                                    <el-select style="width: 300px" v-model="editform.bufferForm" placeholder="请选择缓冲器形式"
                                               clearable>
                                        <el-option label="非线性蓄能型" value="非线性蓄能型"></el-option>
                                        <el-option label="线性蓄能型" value="线性蓄能型"></el-option>
                                        <el-option label="耗能型" value="耗能型"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <div>
                                    <el-form-item label="改造日期格式" prop="updateDateType" style="width: 440px">
                                        <el-select style="width: 300px" v-model="editform.updateDateType"
                                                   @change="getDateType(editform.updateDateType)"
                                                   placeholder="请选择日期格式" clearable>
                                            <el-option label="年月日" :value="'年月日'"></el-option>
                                            <el-option label="年月" :value="'年月'"></el-option>
                                            <el-option label="年" :value="'年'"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="改造日期" class="rightStyle">
                                        <el-date-picker
                                                v-model="editform.updateDate"
                                                type="date"
                                                placeholder="改造日期"
                                                v-if="editform.updateDateType==='年月日'"
                                                format="YYYY年MM月DD日"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.updateDate"
                                                type="date"
                                                placeholder="改造日期"
                                                v-if="editform.updateDateType==='年月'"
                                                format="YYYY年MM月"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.updateDate"
                                                type="date"
                                                placeholder="改造日期"
                                                v-if="editform.updateDateType==='年'"
                                                format="YYYY年"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>

                            </el-col>
                            <el-col :span="12">
                                <div>
                                    <el-form-item label="监督检验日期格式" prop="superviseDateType" style="width: 440px">
                                        <el-select style="width: 300px" v-model="editform.superviseDateType"
                                                   @change="getDateType(editform.superviseDateType)"
                                                   placeholder="请选择日期格式" clearable>
                                            <el-option label="年月日" :value="'年月日'"></el-option>
                                            <el-option label="年月" :value="'年月'"></el-option>
                                            <el-option label="年" :value="'年'"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="监督检验日期" class="rightStyle">
                                        <el-date-picker
                                                v-model="editform.superviseDate"
                                                type="date"
                                                placeholder="监督检验日期"
                                                v-if="editform.superviseDateType==='年月日'"
                                                format="YYYY年MM月DD日"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.superviseDate"
                                                type="date"
                                                placeholder="监督检验日期"
                                                v-if="editform.superviseDateType==='年月'"
                                                format="YYYY年MM月"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.superviseDate"
                                                type="date"
                                                placeholder="监督检验日期"
                                                v-if="editform.superviseDateType==='年'"
                                                format="YYYY年"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>

                                    </el-form-item>
                                </div>

                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="拖动方式" class="rightStyle">
                                    <el-select style="width: 300px" v-model="editform.drag" placeholder="请选择 拖动方式"
                                               clearable>
                                        <el-option label="交流调压调频调速" value="交流调压调频调速"></el-option>
                                        <el-option label="交流调压调速" value="交流调压调速"></el-option>
                                        <el-option label="交流单速" value="交流单速"></el-option>
                                        <el-option label="交流双速" value="交流双速"></el-option>
                                        <el-option label="直流调速" value="直流调速"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="监督检测类型" class="rightStyle">
                                    <el-select style="width: 300px" v-model="editform.superviseType" placeholder="请选择监督检测类型"
                                               clearable>
                                        <el-option label="安装" value="安装"></el-option>
                                        <el-option label="重大修理" value="并联"></el-option>
                                        <el-option label="改造" value="改造"></el-option>
                                    </el-select>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="制动器形式" class="rightStyle">
                                    <el-select style="width: 300px" v-model="editform.brakeForm" placeholder="请选择制动器形式"
                                               clearable>
                                        <el-option label="机电式" value="机电式"></el-option>
                                        <el-option label="非机电式" value="非机电式"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用登记机关" class="rightStyle">
                                    <el-input style="width: 300px" v-model="editform.organ" placeholder="请输入使用登记机关"
                                              clearable autocomplete="off" show-word-limit

                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="悬挂装置" class="rightStyle">
                                    <el-select style="width: 300px" v-model="editform.hang" placeholder="请选择悬挂装置" clearable>
                                        <el-option label="钢丝绳" value="钢丝绳"></el-option>
                                        <el-option label="链条" value="链条"></el-option>
                                        <el-option label="无" value="无"></el-option>
                                        <el-option label="钢带" value="钢带"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="紧急救援电话" class="rightStyle">
                                    <el-input type="number" style="width: 300px" v-model="editform.erpNum"
                                              placeholder="请输入紧急救援电话"
                                              clearable autocomplete="off" show-word-limit

                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="顶升形式" class="rightStyle">
                                    <el-select style="width: 300px" v-model="editform.jacking" placeholder="请选择顶升形式"
                                               clearable>
                                        <el-option label="间接式" value="间接式"></el-option>
                                        <el-option label="直接式" value="直接式"></el-option>
                                        <el-option label="/" value="/"></el-option>
                                        <el-option label="钢带" value="钢带"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="安全管理人员" class="rightStyle">
                                    <el-input v-model="editform.safety" style="width: 300px" placeholder="请输入安全管理人员"
                                              clearable autocomplete="off" show-word-limit

                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="开门形式" class="rightStyle">
                                    <el-select style="width: 300px" v-model="editform.openForm" placeholder="请选择开门形式"
                                               clearable>
                                        <el-option label="自动" value="自动"></el-option>
                                        <el-option label="手动" value="手动"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="安全管理人员电话" class="rightStyle">
                                    <el-input type="number" style="width: 300px" v-model="editform.safetyNum"
                                              placeholder="请输入安全管理人员电话"
                                              clearable autocomplete="off" show-word-limit

                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="名义宽度" class="rightStyle">
                                    <el-input style="width: 300px" type="number" v-model="editform.nominalWidth"
                                              placeholder="请输入名义宽度"
                                              :min="0" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="重大修理单位" class="rightStyle">
                                    <el-input style="width: 300px" v-model="editform.majorUnit" placeholder="请输入重大修理单位"
                                              clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="名义速度" class="rightStyle">
                                    <el-input type="number" v-model="editform.nominalSpeed" placeholder="请输入名义速度"
                                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="施工单位" class="rightStyle">
                                    <el-input style="width: 300px" v-model="editform.buildUnit" placeholder="请输入施工单位"
                                              clearable autocomplete="off" show-word-limit

                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="倾斜角" class="rightStyle">
                                    <el-input type="number" v-model="editform.tilt" placeholder="请输入倾斜角"
                                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="输送能力" class="rightStyle">
                                    <el-input v-model="editform.conveying" placeholder="请输入输送能力"
                                              style="width: 300px" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <div>
                                    <el-form-item label="重大修理日期格式" prop="majorDateType" style="width: 440px">
                                        <el-select style="width: 300px" v-model="editform.majorDateType"
                                                   @change="getDateType(editform.majorDateType)"
                                                   placeholder="请选择日期格式" clearable>
                                            <el-option label="年月日" :value="'年月日'"></el-option>
                                            <el-option label="年月" :value="'年月'"></el-option>
                                            <el-option label="年" :value="'年'"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="重大修理时间" class="rightStyle">
                                        <el-date-picker
                                                v-model="editform.majorDate"
                                                type="date"
                                                placeholder="重大修理时间"
                                                v-if="editform.majorDateType==='年月日'"
                                                format="YYYY年MM月DD日"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.majorDate"
                                                type="date"
                                                placeholder="重大修理时间"
                                                v-if="editform.majorDateType==='年月'"
                                                format="YYYY年MM月"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.majorDate"
                                                type="date"
                                                placeholder="重大修理时间"
                                                v-if="editform.majorDateType==='年'"
                                                format="YYYY年"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>

                                    </el-form-item>
                                </div>

                            </el-col>
                            <el-col :span="12">
                                <div>
                                    <el-form-item label="下次检测日期格式" prop="nextDateType" style="width: 440px">
                                        <el-select style="width: 300px" v-model="editform.nextDateType"
                                                   @change="getDateType(editform.nextDateType)"
                                                   placeholder="请选择日期格式" clearable>
                                            <el-option label="年月日" :value="'年月日'"></el-option>
                                            <el-option label="年月" :value="'年月'"></el-option>
                                            <el-option label="年" :value="'年'"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="下次检测时间" class="rightStyle">
                                        <el-date-picker
                                                v-model="editform.nextDate"
                                                type="date"
                                                placeholder="下次检测时间"
                                                v-if="editform.nextDateType==='年月日'"
                                                format="YYYY年MM月DD日"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.nextDate"
                                                type="date"
                                                placeholder="下次检测时间"
                                                v-if="editform.nextDateType==='年月'"
                                                format="YYYY年MM月"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.nextDate"
                                                type="date"
                                                placeholder="下次检测时间"
                                                v-if="editform.nextDateType==='年'"
                                                format="YYYY年"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>

                                    </el-form-item>
                                </div>

                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="提升高度" class="rightStyle">
                                    <el-input type="number" v-model="editform.liftingHeight" placeholder="请输入提升高度"
                                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="轿门位置" class="rightStyle">
                                    <el-input style="width: 300px" v-model="editform.doorPosition" placeholder="请输入轿门位置"
                                              clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="使用区段长度" class="rightStyle">
                                    <el-input type="number" v-model="editform.section" placeholder="请输入使用区段长度"
                                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="电动机型号" class="rightStyle">
                                    <el-input v-model="editform.electricModel" style="width: 300px" placeholder="请输入电动机型号"
                                              clearable autocomplete="off" show-word-limit

                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="驱动方式" class="rightStyle">
                                    <el-select style="width: 300px" v-model="editform.driving" placeholder="请选择驱动方式"
                                               clearable>
                                        <el-option label="曳引式" value="曳引式"></el-option>
                                        <el-option label="强制式" value="强制式"></el-option>
                                        <el-option label="液压" value="液压"></el-option>
                                        <el-option label="齿轮齿条式" value="齿轮齿条式"></el-option>
                                    </el-select>

                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="桥厢尺寸宽度" class="rightStyle">
                                    <el-input type="number" style="width: 300px" v-model="editform.bridgeBoxWidth"
                                              placeholder="请输入桥厢尺寸宽度"
                                              :min="0" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="机房形式" class="rightStyle">
                                    <el-select style="width: 300px" v-model="editform.computer" placeholder="请选择机房形式"
                                               clearable>
                                        <el-option label="有机房" value="有机房"></el-option>
                                        <el-option label="无机房" value="无机房"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="桥厢尺寸深度" class="rightStyle">
                                    <el-input type="number" style="width: 300px" v-model="editform.bridgeBoxDeep"
                                              placeholder="请输入桥厢尺寸深度"
                                              :min="0" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="驱动主机布置" class="rightStyle">
                                    <el-select style="width: 300px" v-model="editform.assign" placeholder="请选择驱动主机布置"
                                               clearable>
                                        <el-option label="井道内上置" value="井道内上置"></el-option>
                                        <el-option label="井道内下置" value="井道内下置"></el-option>
                                        <el-option label="上置机房内" value="上置机房内"></el-option>
                                        <el-option label="侧置机房内" value="侧置机房内"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="桥厢尺寸高度" class="rightStyle">
                                    <el-input type="number" style="width: 300px" v-model="editform.bridgeBoxHigth"
                                              placeholder="请输入桥厢尺寸高度"
                                              :min="0" clearable autocomplete="off" show-word-limit
                                              maxlength="50" required></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <div>
                                    <el-form-item label="下次检验日期格式" prop="nextTestDateType" style="width: 440px">
                                        <el-select style="width: 300px" v-model="editform.nextTestDateType"
                                                   @change="getDateType(editform.nextTestDateType)"
                                                   placeholder="请选择日期格式" clearable>
                                            <el-option label="年月日" :value="'年月日'"></el-option>
                                            <el-option label="年月" :value="'年月'"></el-option>
                                            <el-option label="年" :value="'年'"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="下次检验时间" class="rightStyle">
                                        <el-date-picker
                                                v-model="editform.nextTestDate"
                                                type="date"
                                                placeholder="下次检验时间"
                                                v-if="editform.nextTestDateType==='年月日'"
                                                format="YYYY年MM月DD日"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.nextTestDate"
                                                type="date"
                                                placeholder="下次检验时间"
                                                v-if="editform.nextTestDateType==='年月'"
                                                format="YYYY年MM月"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>
                                        <el-date-picker
                                                v-model="editform.nextTestDate"
                                                type="date"
                                                placeholder="下次检验时间"
                                                v-if="editform.nextTestDateType==='年'"
                                                format="YYYY年"
                                                style="width: 300px"
                                        >
                                        </el-date-picker>

                                    </el-form-item>
                                </div>

                            </el-col>


                        </el-row>
                    </div>

                </el-form>
            </el-col>
        </el-row>
        <template #footer>
            <div style="margin: 0 auto ; text-align: center ">
                <el-button @click="closeDialog(1,'editform')">关闭</el-button>
                <!--          <el-button    @click="dialogFormVisibleEdit = false">退出</el-button>:disabled="isupdate"-->
                <el-button type="primary" @click="edit('editform')">确定</el-button>
            </div>

        </template>
    </el-dialog>
    <el-dialog v-model="BackDialog" title="通知" :lock-scroll="false"
               width="80%">
        <span>将清除记录,视频和图片</span>
        <template #footer>
            <div style="margin: 0 auto ; text-align: center ">
                <el-button @click="BackDialog=false">关闭</el-button>
                <el-button type="primary" @click="recordBack()">确定</el-button>
            </div>

        </template>
    </el-dialog>
    <el-dialog v-model="showBack" title="生成备忘录" :lock-scroll="false"
               width="80%">
        <view>
            <el-upload
                    class="upload-demo"
                    :action="this.ip+'/detection/signPic'"
                    :on-success="handleAvatarSuccess"
                    :on-remove="handleRemove"
                    :limit="1"

                    :before-upload="beforeAvatarUpload"
                    ref="upload"
            >
<!--                :show-file-list="false"-->
                <el-button size="small" type="primary">点击上传客户签名</el-button>
                <template #tip>
                    <div class="el-upload__tip">
                        只能上传jpg/png文件，且不超过2M
                    </div>
                </template>
            </el-upload>

        </view>
        <template #footer>
            <div style="margin: 0 auto ; text-align: center ">
                <el-button @click="showBack=false">关闭</el-button>
                <el-button type="primary" @click="creatNotice()">确定</el-button>
            </div>

        </template>
    </el-dialog>
</template>

<script>
    import request from "../../util/request";
    import {ElLoading} from "element-plus";
    export default {
        name: "detectionInfo",
        data(){
            return {
                BackDialog:false,
                editform:{},
                dialogFormVisibleEdit:false,
                eqptypeList:[],
                areaList: [],
                areaList2: [],
                areaList3: [],
                areaParentIdOne: '',
                areaParentIdTwo: '',
                areaParentIdThree: '',
                tep: 0, //用于点击时改变状态
                // explains: [], //保存现场条件数据
                userName: sessionStorage.getItem("userName"),
                messageText: '不是主检，无操作权限',
                showBack: false, //生成备忘录弹窗
                pgList: [],
                current: 0,
                count: 0, //点击显示隐藏退出按钮
                instrumentNum: '', //仪器组号
                InstrumentStatus: '', //仪器状态
                temp: '', //温度
                humidity: '', //湿度
                voltage: '', //电压
                windSpeed: '', //风速
                saveName: [], //已选择的现场条件或设备信息的内容
                saveID: [], //已选择的说明的id
                explainList: [],
                type: 'center',
                msgType: 'success',
                SaveExplainList: [], //保存的说明列表
                saveExplainId: [],
                Record: {}, //记录
                orderAreaDevice: {}  , //工单设备信息
                MaxtiemList: [], //模板大项的列表
                moduleList: [], //模块名
                detectioncount: [], //检测项的总数
                successList: [], //检测合格项
                falseList: [], //检测不合格项
                vDeviceArea: {}, //设备信息
                ip: localStorage.getItem("ip"), //端口和IP地址
                chickReport: 0, //判断是否点击了生成报告
                userAlias: sessionStorage.getItem("userAlias"), //姓名
                maxDetailsList: [], //保存的大项描述表列表
                meg: '',
                deviceId: "",
                power: "",
                totalmemory: "",
                nowmemory: "",
                totalTmemory: "",
                nowTmemory: "",
                path: "",
                FormData: {},
                selectvalue: '',
                // 当前页
                pageCurrent: 1,
                // 每页数据量
                pageSize: 10,
                // 数据总量
                total: 10,
            };
        },
        created() {
            this.getInfo();
            this.queryExplain();
            this.queryDeviceInfo(-1);
        },
        methods: {

            getInfo() {
                var data = sessionStorage.getItem("Record")  //取出缓存数据
                var res = JSON.parse(data)
                this.Record = res;
                if (this.Record.csignDate == null || this.Record.csignDate == "") {
                    this.Record.csignDate = this.formatDate(new Date(), "yyyy年MM月dd日")
                }
                if (this.Record.videoUrl != null) {
                    if (this.Record.videoUrl.length > 0) {
                        this.videoUrl = this.Record.videoUrl
                    }
                }
                var orderAreaDevice = sessionStorage.getItem('orderAreaDevice') //取出缓存数据
                var resData = JSON.parse(orderAreaDevice)
                this.orderAreaDevice = resData
            },
            queryDeviceInfo(id) { //查询设备信息
                request.get('/detection/queryDecice', {
                    params: {
                        liftId: this.orderAreaDevice.liftId
                        // liftId: 1971
                    }
                }).then(res => {
                    console.log(res.data);
                    this.vDeviceArea = res.data;
                    if (id === -1) {
                        this.queryMaxTiem();
                    }
                })
            },
            //时间格式
            formatDate(value, fmt) {
                let getDate = new Date(value);
                let o = {
                    'M+': getDate.getMonth() + 1,
                    'd+': getDate.getDate(),
                    'h+': getDate.getHours(),
                    'm+': getDate.getMinutes(),
                    's+': getDate.getSeconds(),
                    'q+': Math.floor((getDate.getMonth() + 3) / 3),
                    'S': getDate.getMilliseconds()
                };
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
                }
                for (let k in o) {
                    if (new RegExp('(' + k + ')').test(fmt)) {
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
                    }
                }
                return fmt;
            },
            //查询检测场景信息
            queryMaxTiem() {
                request.get('/detection/queryMaxTiem', {
                    params: {
                        TemplateId: this.Record.templateId,
                        // TemplateId: 12,
                        recId: this.Record.recId
                        // recId: 2450
                    }
                }).then(res => {
                    this.moduleList = [];
                    this.detectioncount = []; //检测项的总数
                    console.log(res.data);
                    this.detectioncount = res.data.countList;
                    this.MaxtiemList = res.data.maxtermList;
                    this.maxDetailsList = res.data.maxDetailsList;

                    this.moduleList = res.data.moduleList;
                    this.successList = res.data.successList;
                    this.falseList = res.data.falseList;
                    for (var i = 0; i < this.detectioncount.length; i++) {
                        if (this.detectioncount[i] > 0) {
                            let sum = (this.successList[i] + this.falseList[i]) / this
                                .detectioncount[i] * 100;
                            this.pgList[i] = Number(sum.toFixed(2))
                        }
                    }
                    console.log(this.detectioncount + "this.detectioncount");
                })
            },
            //查询现场条件
            queryExplain() {
                let vm = this;
                request.post('/detection/queryExplain').then(res => {
                    vm.explainList = res.data;
                    if (vm.explainList.length > 0) {
                        vm.querySaveExplain();
                    }
                })
            },
            querySaveExplain() { //查询保存的现场条件项
                let vm = this;
                request.get('/detection/querySaveExplain', {
                    params: {
                        recId: this.Record.recId
                        // recId: 2450
                    }
                }).then(res => {
                    // console.log(res.data);
                    vm.SaveExplainList = res.data;
                    var items = vm.explainList;
                    let values = [];
                    values = vm.SaveExplainList;
                    // console.log(values + "------values--" + typeof values);
                    let list = [];
                    if (values != null) {
                        this.saveID = [];
                        for (var t = 0; t < values.length; t++) {
                            list[t] = values[t].explainId
                        }
                        for (var i = 0, lenI = items.length; i < lenI; ++i) {
                            const item = items[i];
                            for (var j = 0; j < values.length; j++) {
                                // console.log(111);
                                if (values[j].explainId == (item.explainId)) {
                                    if (item.explainId == 1) {
                                        if (values[j].tempMore != null) {
                                            let tempMore = values[j].tempMore.split(",");
                                            this.temp = tempMore[0];
                                            this.humidity = tempMore[1];
                                            this.voltage = tempMore[2];
                                        }
                                    }
                                    let saveExplainName = item.explainId;
                                    this.saveID.push(item.explainId);
                                    this.saveName.push(saveExplainName);
                                }
                                // console.log(this.saveID + "----this.saveID111");
                                // console.log(this.saveName + "----this.saveName");
                                this.instrumentNum = values[j].instrumentNum;
                                this.InstrumentStatus = values[j].instrumentStatus;
                            }

                        }
                    }
                })

            },
            handleCheckedCitiesChange(value) {
                // let checkedCount = value.length;
                console.log(value)
                this.saveName = this.saveID;
                this.updateSaveExplain();
            },
            getEqpType(EqpType, id) {//查询设备类别
                console.log(EqpType, id);
                this.eqptypeList = [];
                request.post('/Device/getEqpType', EqpType).then(res => {
                    console.log(res.code + res.mag + res.data + "getEqpType" + res);
                    if (res.code === "0") {
                        this.eqptypeList = res.data;
                    } else {
                        this.$message({
                            message: "查询设备类别失败",
                            type: "error"
                        });

                    }
                })
            },
            getliftType(lifeKind, id) {//查询设备品种
                console.log(lifeKind);

                this.liftTypeList = [];
                request.get('/Device/getliftType?lifeKind=' + lifeKind).then(res => {
                    console.log(res.code + res.mag + res.data + "getliftType" + res);
                    if (res.code === "0") {
                        this.liftTypeList = res.data;
                        if (id === 0) {
                            // this.form.liftType = '';
                        } else {
                            for (let i = 0; i < this.liftTypeList.length; i++) {
                                if (this.liftTypeList.find(e => e.liftType === this.editform.liftType)) {
                                    console.log(222);
                                } else this.editform.liftType = '';
                            }
                        }
                    } else {
                        this.$message({
                            message: "查询设备品种失败",
                            type: "error"
                        });
                        this.editform.liftType = '';
                        // this.form.liftType = '';
                    }
                })
            },
            //修改设备按钮点击事件
            update(row) {
                this.dialogFormVisibleEdit = true;
                this.editform = JSON.parse(JSON.stringify(row));

                this.getEqpType(this.editform.specialType);
                this.getliftType(this.editform.lifeKind, 1);
                request.post('/Device/ParentArea', this.editform.areaId).then(res => {
                    console.log(res.data);

                    this.areaList = res.data.deviceAreas1;
                    for (let i = 0; i < this.areaList.length; i++) {
                        if (this.areaList[i].areaId === res.data.areaId1) {
                            this.areaParentIdOne = i;
                        }
                    }
                    this.areaList2 = res.data.deviceAreas2;
                    for (let i = 0; i < this.areaList2.length; i++) {
                        if (this.areaList2[i].areaId === res.data.areaId2) {
                            this.areaParentIdTwo = i;
                        }
                    }
                    this.areaList3 = res.data.deviceAreas3;
                    for (let i = 0; i < this.areaList3.length; i++) {
                        if (this.areaList3[i].areaId === res.data.areaId3) {
                            this.areaParentIdThree = i;
                        }
                    }

                })
            },
            //修改设备数据
            edit(formName) {
                if (!this.validator()) {//验证不通过
                    return false;
                }
                console.log(formName);
                this.editform.areaId = this.areaList3[this.areaParentIdThree].areaId;
                let device = null;
                device = {
                    liftId: this.editform.liftId,
                    areaId: this.editform.areaId,
                    // dateType: this.editform.dateType,
                    unit: this.editform.unit,
                    unitCode: this.editform.unitCode,
                    loginNum: this.editform.loginNum,
                    unitNum: this.editform.unitNum,
                    liftType: this.editform.liftType,
                    liftModel: this.editform.liftModel,
                    liftNum: this.editform.liftNum,
                    createUnit: this.editform.createUnit,
                    createDate: this.editform.createDate,
                    // createDate: this.dateType(this.editform.createDateType, this.editform.createDate),
                    createStandard: this.editform.createStandard,
                    updateUnit: this.editform.updateUnit,
                    updateDate: this.editform.updateDate,
                    // updateDate: this.dateType(this.editform.updateDateType, this.editform.updateDate),
                    maintenance: this.editform.maintenance,
                    superviseDate: this.editform.superviseDate,
                    // superviseDate: this.dateType(this.editform.superviseDateType, this.editform.superviseDate),
                    superviseType: this.editform.superviseType,
                    organ: this.editform.organ,
                    erpNum: this.editform.erpNum,
                    safety: this.editform.safety,
                    safetyNum: this.editform.safetyNum,
                    majorUnit: this.editform.majorUnit,
                    buildUnit: this.editform.buildUnit,
                    majorDate: this.editform.majorDate,
                    // majorDate: this.dateType(this.editform.majorDateType, this.editform.majorDate),
                    nextDate: this.editform.nextDate,
                    // nextDate: this.dateType(this.editform.nextDateType, this.editform.nextDate),
                    nextTestDate: this.editform.nextTestDate,
                    // nextTestDate: this.dateType(this.editform.nextTestDateType, this.editform.nextTestDate),
                    lifeCode: this.editform.lifeCode,
                    lifeRegistCode: this.editform.lifeRegistCode,
                    lifeKind: this.editform.lifeKind,
                    electricModel: this.editform.electricModel,
                    bridgeBoxWidth: this.editform.bridgeBoxWidth,
                    bridgeBoxDeep: this.editform.bridgeBoxDeep,
                    bridgeBoxHigth: this.editform.bridgeBoxHigth,
                    pressure: this.editform.pressure,
                    speed: this.editform.speed,
                    speedUp: this.editform.speedUp,
                    speedDown: this.editform.speedDown,
                    hcNum: this.editform.hcNum,
                    maxPressure: this.editform.maxPressure,
                    upStation: this.editform.upStation,
                    downStation: this.editform.downStation,
                    baseStation: this.editform.baseStation,
                    hangType: this.editform.hangType,
                    hangNum: this.editform.hangNum,
                    flameProof: this.editform.flameProof,
                    material: this.editform.material,
                    materialSign: this.editform.materialSign,
                    testedNum: this.editform.testedNum,
                    bufferForm: this.editform.bufferForm,
                    safetyGear: this.editform.safetyGear,
                    drag: this.editform.drag,
                    brakeForm: this.editform.brakeForm,
                    hang: this.editform.hang,
                    jacking: this.editform.jacking,
                    openForm: this.editform.openForm,
                    maxWeight: this.editform.maxWeight,
                    nominalSpeed: this.editform.nominalSpeed,
                    nominalWidth: this.editform.nominalWidth,
                    tilt: this.editform.tilt,
                    conveying: this.editform.conveying,
                    liftingHeight: this.editform.liftingHeight,
                    section: this.editform.section,
                    controller: this.editform.controller,
                    driving: this.editform.driving,
                    computer: this.editform.computer,
                    assign: this.editform.assign,
                    storey: this.editform.storey,
                    stand: this.editform.stand,
                    door: this.editform.door,
                    doorPosition: this.editform.doorPosition,

                    testType: this.editform.testType,
                    specialType: this.editform.specialType,
                    superviseCode: this.editform.superviseCode,
                    lifeArea: this.editform.lifeArea,
                    propertyName: this.editform.propertyName,
                    branchName: this.editform.branchName,
                    driveModel: this.editform.driveModel,
                    driveCode: this.editform.driveCode,
                    controlBoxModel: this.editform.controlBoxModel,
                    controlBoxCode: this.editform.controlBoxCode,
                    carModel: this.editform.carModel,
                    carCode: this.editform.carCode,
                    counterweightModel: this.editform.counterweightModel,
                    counterweightModelCode: this.editform.counterweightModelCode,
                    unitArea: this.editform.unitArea,
                    branchArea: this.editform.branchArea,
                    propertyArea: this.editform.propertyArea,
                    proof: this.editform.proof,
                    preDate: this.editform.preDate,
                    // preDate: this.dateType(this.editform.preDateType, this.editform.preDate),
                    preDateType: this.editform.preDateType,
                    updateDateType: this.editform.updateDateType,
                    nextDateType: this.editform.nextDateType,
                    createDateType: this.editform.createDateType,
                    superviseDateType: this.editform.superviseDateType,
                    majorDateType: this.editform.majorDateType,
                    nextTestDateType: this.editform.nextTestDateType,
                    detailArea: this.editform.detailArea,
                };

                this.$confirm('是否提交?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.count++;
                    if (this.count >= 2) {
                        this.$message({
                            message: "正在处理...",
                            type: "warning"
                        });
                        return
                    }
                    request.post('/Device/update', device).then(res => {
                        this.count = 0;
                        if (res.code === "0") {
                            this.$message({
                                message: "编辑成功",
                                type: "success"
                            });
                            this.queryDeviceInfo(1);
                            this.dialogFormVisibleEdit = false;
                        } else {
                            this.$message({
                                message: "编辑失败",
                                type: "error"
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });

            },
            validator() {//表单验证
                if (this.dialogFormVisibleEdit) {//修改
                    if (this.editform.specialType === '' || this.editform.specialType === null || this.editform.specialType === undefined) {
                        this.$message({
                            message: "请选择设备种类",
                            type: "warning"
                        });
                        return false;
                    }
                    if (this.editform.detailArea === '' || this.editform.detailArea === null || this.editform.detailArea === undefined) {
                        this.$message({
                            message: "请选择具体地址",
                            type: "warning"
                        });
                        return false;
                    } else this.editform.detailArea = this.editform.detailArea.toString().trim();
                    if (this.editform.unit === '' || this.editform.unit === null || this.editform.unit === undefined) {
                        this.$message({
                            message: "请输入使用单位名称",
                            type: "warning"
                        });
                        return false;
                    } else this.editform.unit = this.editform.unit.toString().trim();
                    if (this.editform.lifeKind === '' || this.editform.lifeKind === null || this.editform.lifeKind === undefined) {
                        this.$message({
                            message: "请输入设备类别",
                            type: "warning"
                        });
                        return false;
                    } else this.editform.lifeKind = this.editform.lifeKind.toString().trim();
                    if (this.editform.superviseCode === '' || this.editform.superviseCode === null || this.editform.superviseCode === undefined) {
                        this.$message({
                            message: "请输入监察识别码",
                            type: "warning"
                        });
                        return false;
                    } else {
                        this.editform.superviseCode = this.editform.superviseCode.toString().trim();

                    }
                    if (this.editform.maintenance === '' || this.editform.maintenance === null || this.editform.maintenance === undefined) {
                        this.$message({
                            message: "请输入维护保养单位",
                            type: "warning"
                        });
                        return false;
                    } else this.editform.maintenance = this.editform.maintenance.toString().trim();

                }
                if (this.areaParentIdThree === '' || this.areaParentIdThree === null || this.areaParentIdThree === undefined) {
                    this.$message({
                        message: "请选择区或镇",
                        type: "warning"
                    });
                    return false;
                }
                return true;
            },
            deleteSaveExplain(Id) { //删除保存的现场条件
                let vm = this;
                let map = {
                    "saveExplainId": Id
                }
                request.post('/detection/deleteSaveExplain', map).then(res => {
                    console.log(res.data);
                    vm.addSaveExplain(vm.saveID);
                })
            },
            addSaveExplain(id) { //添加保存的现场条件项
                // console.log(id + "---------saveID");
                let tempMore = "";
                tempMore = this.temp + "," + this.humidity + "," + this.voltage;
                let map = {
                    "recId": this.Record.recId,
                    // "recId": 2450,
                    "saveID": id,
                    "saveName": this.saveName,
                    "tempMore": tempMore,
                    "saveDavice": this.saveName,
                    "instrumentNum": this.instrumentNum,
                    "InstrumentStatus": this.InstrumentStatus
                };
                request.post('/detection/addSaveExplain', map).then(res => {
                    console.log(res.data);
                })

            },
            updateSaveExplain() { //修改保存的现场条件
                let deleList = [];
                let vm = this;
                request.get('/detection/querySaveExplain', {
                    params: {
                        "recId": this.Record.recId
                        // recId: 2450
                    }
                }).then(res => {
                    vm.SaveExplainList = res.data;
                    if (vm.SaveExplainList != null) {
                        for (var i = 0; i < vm.SaveExplainList.length; i++) {
                            deleList.push(vm.SaveExplainList[i].saveExplainId);
                        }
                    }
                    vm.deleteSaveExplain(deleList);
                },)
            },
            //跳转到检测项
            queryHoistway(name){
                this.$router.push({path: 'Hoistway', query: {name: name, specialType: 1, storey: this.vDeviceArea.storey}})
            },
            toObserved() {
                this.$router.push({path: 'Observed', query: {recId: this.Record.recId}})
            },
            //保存检测日期
            detectionDateChange: function (e) {
                // this.Record.recDate = e.detail.value;
                this.Record.recDate = e;
                console.log(e)
                let str =null;
                if (this.Record!=null&& this.Record!=""){
                    str = JSON.stringify(this.Record) ;
                }
                request.get('/detection/updateRecordRecDate', {
                    params: {
                        "Record": str,
                    }
                }).then(res => {
                    console.log(res.data);
                });
            },
            //保存签收日期
            csDateChange: function (e) {
                // this.Record.recDate = e.detail.value;
                this.Record.csignDate = e;
                console.log(e)
                console.log(this.Record)
                let str =null;
                if (this.Record!=null&& this.Record!=""){
                    str = JSON.stringify(this.Record) ;
                }
                console.log(typeof str)
                request.get('/detection/updateRecordRecDate', {
                    params: {
                        "Record": str,
                    }
                }).then(res => {
                    console.log(res.data);
                });
            },
            clickBack() {
                this.BackDialog = true;
            },
            recordBack() {//退回
                request.get('/detection/RollbackProcedures', {
                    params: {
                        recId: this.Record.recId
                    }
                }).then(res => {
                    console.log(res.data);
                    this.BackDialog = false;
                    this.$router.push({path: 'startDetect'})
                },)
            },
            toshowToast() { //提示还有哪些具体检测项未选择，显示共几项未选择
                if (this.MaxtiemList.length > 0 && this.maxDetailsList.length > 0) {
                    if (this.MaxtiemList.length == this.maxDetailsList.length) return true;
                    const maxtermIds = this.maxDetailsList.map(e => e.maxtermId);
                    let orders = this.MaxtiemList.filter(e => !maxtermIds.includes(e.maxtermId));

                    let str = '未检测:';
                    for (var i = 0; i < orders.length; i++) {
                        if (orders.length > 5 && i < 5) {
                            if (orders[i].maxtermKind === '1') {
                                str += (orders[i].maxtermNo + "*;");
                            } else {
                                str += orders[i].maxtermNo + ";";
                            }
                        } else if (orders.length < 5 && i < 5) {
                            if (orders[i].maxtermKind === '1') {
                                str += (orders[i].maxtermNo + "*;");
                            } else {
                                str += orders[i].maxtermNo + ";";
                            }
                        }
                    }
                    this.meg = str + "...等,共" + orders.length + "项未检测";
                    // this.$refs.detected.open('top');
                    this.$message({
                        type: 'warning',
                        message: this.meg
                    });
                }
            },
            creatReport(id) { //点击生成报告按钮
                if (this.vDeviceArea.createStandard == null || this.vDeviceArea.createStandard === undefined || this
                    .vDeviceArea.createStandard === '') {
                    this.$message({
                        message: "未选择制造执行标准",
                        type: "warning"
                    });
                    return false;
                }
                let b = false;
                let falseB = false;
                if (this.successList.length > 0) {
                    for (var i = 0; i < this.successList.length; i++) {
                        if (this.successList[i] > 0) {
                            b = true
                        }
                    }
                }
                if (this.falseList.length > 0) {
                    for (let i = 0; i < this.falseList.length; i++) {
                        if (this.falseList[i] > 0) {
                            falseB = true
                        }
                    }
                }

                if (b || falseB) {
                    this.toshowToast();
                } else {
                    this.$message({
                        message: "未选择检测项",
                        type: "warning"
                    });
                    return false;
                }
                if (this.saveID.length == 0) {
                    this.$message({
                        message: "未选择现场条件",
                        type: "warning"
                    });
                    return false;
                } else {
                    this.tocreatReport(id); //生成报告
                }
            },
            tocreatReport(id) {
                this.chickReport = id;
                const loading = ElLoading.service({ // 打开遮罩层
                    lock: true,
                    text: '请稍等...',
                    background: 'rgba(255, 255, 255, 0.5)',
                })
                let vm = this;
                let map ={
                    "recId":this.Record.recId
                }
                //生成报告
                request.post('/detection/report',map ).then(res => {
                    // console.log(typeof res.data);
                    console.log(res.data);
                    let record = res.data;
                    if (record != null) {
                        loading.close() // 关闭遮罩层
                        vm.createRecord(record);
                    } else {
                        loading.close; //结束加载中
                        this.$message({
                            message: "生成报告失败",
                            type: "error"
                        });
                    }
                })
            },
            createRecord(record,id) {
                let vm = this;
                let map ={
                    "recId":record.recId
                }
                //生成记录pdf
                request.post('/detection/reportquery', map ).then(res => {
                    // vm.showBack.close; //结束加载中
                    if(id===1){
                        let record = res.data;
                       window.open(record.recordUrl);
                    }else {
                        if (vm.chickReport === 1) {
                            let record = res.data;
                            // let Record = JSON.stringify(record);
                            // sessionStorage.setItem('Record', JSON.stringify(Record))
                            // this.$router.push({path: 'RecordPdf', query: {reportUrl: record.reportUrl,tep:0}})
                            window.open(record.reportUrl);
                        } else {
                            vm.updateRecord();
                        }
                    }
                })
            },
            updateRecord() { //修改记录状态
                // let vm = this;
                request.get('/detection/updateRecord', {
                    params: {
                        Record: this.Record
                    }
                }).then(res => {
                    console.log(res.data);
                    if (res.code==="0"){
                        let record = res.data;
                        // let Record = JSON.stringify(record);
                        // sessionStorage.setItem('Record', JSON.stringify(Record))
                        window.open(record.reportUrl);
                        this.$router.push({path:'startDetect'})
                    }else {
                        this.$message({
                            message: "生成报告失败",
                            type: "error"
                        });
                    }
                })
            },
            //打开备忘录弹窗
            TocreatNotice(){
                this.showBack =true;
            },
            //跳转到备忘录预览页面
            creatNotice() {
                let vm =this;
              let  map={
                    "recId" : vm.Record.recId,
                        "Id" : 0,
                        "signature" :  sessionStorage.getItem("imgUrl")
                };
                //生成告知书
                  request.post('/detection/notice',map).then(res => {
                       let record =res.data;
                         window.open(record.noticeUrl);
                         this.showBack=false;
                    })

            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG && !isPNG) {
                    this.$message.error('上传签名图片只能是 JPG 或者是 PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传签名图片大小不能超过 2MB!');
                }
                return (isJPG && isLt2M) || (isPNG && isLt2M);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            //上传签名成功后
            handleAvatarSuccess(res, file) {
                // this.resultImg = URL.createObjectURL(file.raw);
                // this.imageUrl = URL.createObjectURL(file.raw);
                console.log(file)
                console.log(file.response)
                sessionStorage.setItem("imgUrl",file.response)
                // this.editform.userSign = file.response.data
            },
        }

    }
</script>

<style scoped>
    .infoCard {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        /*flex-wrap: wrap;*/

    }
    .infoCard_box {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        /*align-items: flex-start;*/
        /*flex-wrap: nowrap;*/
        /*width: 1100px;*/
    }

    .infoCard_boxnet {
        /*width: 560px;*/
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }

    .infoCard_boxinp {
        line-height: 3;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        /*padding-bottom: 10px;*/
    }
    .infoCard_box3 {

        height: 60px;
        line-height: 60px;
        /* padding-bottom: 29rpx; */
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
    }

    .infoCard_box3text {
        color: #3C4353;
        font-size: 18px;
        width: 190px;
        height: 29px;
        line-height: 30px;
        position: relative;
        flex: 2;
        left: -10px;
        top: 0px;
    }

    .infoCard_box3but {
        color: #FFF;
        border-radius: 45px;
        font-size: 14px;
        height: 29px;
        line-height: 30px;
        position: relative;
        left: 15px;
        top: 0px;
    }

    .infoCard_box3net {
        display: flex;
        flex-direction: row;
        justify-content: space-around;

        /* padding-bottom: 20rpx; */
    }

    .infoCard_box3netboy {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin-right: 10px;
    }

    .infoCard_box3netboytxtl {
        color: #838A9D;
        font-size: 18px;
        /* padding-bottom: 20rpx; */
    }

    .infoCard_box3netboytxtr {
        text-align: center;
        color: #000;
        font-size: 18px;
    }

    .infoCard_box3netboytxtr2 {
        text-align: center;
        color: #ff0000;
        font-size: 18px;
    }
    .footcard {
        /* width: 100%; height: 104rpx;
            position: fixed;right: 0rpx;bottom:0rpx; margin: 0 !important;padding-left: 10rpx !important; */
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        background-color: #fff;
        z-index: 10;
        width: 100%;
        height: 104px;

    }
</style>